import { useNavigate } from "react-router-dom"
import { ModalId, useUIActions, useUIStateActions } from "../../../../../features/ui"
import { useServer } from "../../../../../services/server"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { TableName } from "../../../../../tables"
import { InvoiceItemQuantity, InvoiceMode, SaleOperation, useSaleOperationLoaders, useSaleOperationService } from "../../../../sales"
import { FiscalDocumentClass, FiscalDocumentType, useFiscalDocumentLoaders, Discount } from "../../../../fiscal-documents"
import { VatCondition } from "../../../state/types"
import { identifierType } from "../../../../../features/data-types"
import { Address } from "../../../../../features/address"
import { PreviewBodyItem } from "../../../../../services/server"

type InvoicePreviewParams = {
    items: PreviewBodyItem[]
    discounts?: Discount[]
    fiscalDocumentId?: string
    customerGrossIncomeProvinces?: string[]
    customerEmail?: string
    customerAddress?: Address
}

type InvoiceParams = {
    fiscalDocumentId: string
    mode?: InvoiceMode
    itemQuantities?: InvoiceItemQuantity[]
    fullInvoice?: boolean
}

export const useActions = () => {
    const { getRoutePath } = useRoutesHooks()
    const navigate = useNavigate()

    const saleOperationLoaders = useSaleOperationLoaders()
    const fiscalDocumentLoaders = useFiscalDocumentLoaders()

    const { setSpinnerModalMessage } = useUIStateActions()
    const { openModal, closeModal } = useUIActions()
    
    const { invoiceSaleOperation } = useSaleOperationService()
    const { getTaxPayerData, invoiceSaleOperationPreview } = useServer()

    const invoicePreview = async (
        companyTaxId: number,
        table: TableName,
        operation: SaleOperation,
        fiscalClass: FiscalDocumentClass,
        customerIdentifier: number,
        customerName: string,
        vatCondition: VatCondition,
        saleProvince: string,
        params: InvoicePreviewParams
    ) => {
        return invoiceSaleOperationPreview(
            companyTaxId,
            table,
            operation.id,
            FiscalDocumentType.INVOICE,
            fiscalClass!,
            saleProvince,
            identifierType(customerIdentifier),
            customerIdentifier,
            params.items,
            customerName,
            vatCondition!,
            params.customerGrossIncomeProvinces,
            params.customerEmail,
            params.customerAddress,
            params.fiscalDocumentId,
            params.discounts
        )
    }

    const invoice = async (
        table: TableName,
        operationId: string,
        params: InvoiceParams
    ) => {
        setSpinnerModalMessage('Enviando a facturar...')
        openModal(ModalId.SPINNER)
        
        try {
            await invoiceSaleOperation(params)
    
            const { loadSaleOperation } = saleOperationLoaders()
            await loadSaleOperation(table, operationId, true)
            const { loadOperationFiscalDocuments } = fiscalDocumentLoaders()
            await loadOperationFiscalDocuments(operationId, false)
            
            closeModal(ModalId.SPINNER)
            navigate(getRoutePath(table === TableName.SALE_ORDERS ? RoutePath.SALES : RoutePath.HOARDS, operationId))
            setTimeout(() => {
                openModal(ModalId.INVOICE_REQUESTED)
            }, 1500)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            throw error
        }
    }

    return {
        getTaxPayerData,
        invoicePreview,
        invoice
    }
}
